import { useAppContext } from 'context/AppContext'

const useSecureFetch = () => {
  const { csrf } = useAppContext()

  return (url, { headers = {}, ...args }) => {
    return fetch(url, { ...args, headers: { ...headers, 'X-Csrf-Token': csrf } })
  }
}

export default useSecureFetch
